import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import { httpPost } from "../../../../utility/requestHelper";
import ReactGA from "react-ga4";
import {
  FilterIcon,
  MenuIcon,
  NoFeedIcon,
} from "../../../Icons/icons.component";
import ShareArticle from "../../../Shared/ShareArticle";
import DateRangeFilter from "../../Filters/DateRangeFilter";
import Filters from "../../Filters/Filters";
import ArticleTags from "../ArticleTags";
import DownloadFeeds from "../DownloadFeeds";
import TopicWiseNewsContainer from "../PrintAndOnline/TopicWiseNewsContainer";
import {
  arrayToString,
  getSearchApiDateFormat,
} from "../../../../utility/common-methods";
import { useSelector } from "react-redux";
import { getCookie } from "../../../../utility/cookieProvider";
import { COOKIE } from "../../../../constants/app-constant";
import { envConfig } from "../../../../constants/api-endpoint";
import Loader from "../../../Shared/Loader";
import {GACODE} from "../../../../constants/app-constant";

const initDate = getSearchApiDateFormat();

export default function Tv() {
  const listContainerRef = useRef(null);
  ReactGA.initialize(GACODE);
  const [filters, setFilters] = useState({
    tonality: null,
    zone: null,
    entity: null,
    category: null,
    client: selectedClientId,
    headline: null,
    keywords: null,
    typedPublication: null,
    typedReporter: null,
    reporter: [],
    source_type: null,
    press_release: null,
    favourite: null,
    languages: "",
    channels: "",
    anchor: "",
  });
  const [showFilter, toggleFilter] = useState(false);
  const [startRange, setStartRange] = useState(initDate);
  const [endRange, setEndRange] = useState(initDate);
  const email = getCookie(COOKIE.CONCEPT_USER_EMAIL);
  const user_id = getCookie(COOKIE.CONCEPT_USER_ID);
  const [selectedFeeds, setSelectedFeeds] = useState([]);
  const [selectedFeedsGroup, setSelectedFeedsGroup] = useState([]);
  const [activeKey, setActiveKey] = useState(-1);
  const [isLoading, setIsLoading] = useState(true);
  const [tvFeeds, setTvFeeds] = useState({});
  const [totalFeedCount, setTotalFeedCount] = useState(null);
  const [appliedFilters, setApplyFilters] = useState(false);
  const [updatedBulkSentiment, setUpdatedBulkSentiment] = useState("");
  const [updatedBulkFavourite, setUpdatedBulkFavourite] = useState("");
  const [updatedBulkTheme, setUpdatedBulkTheme] = useState(undefined);
  const [selectAll, setSelectAll] = useState(true);
  const [isLoad, setIsLoad] = useState(false);

  const entityList =
    useSelector(
      (state) =>
        state.entityAndKeyWordsReducer &&
        state.entityAndKeyWordsReducer.entityDetails &&
        state.entityAndKeyWordsReducer.entityDetails.entityList
    ) || [];
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || {};
  const channelList =
    useSelector((state) => state.filterReducer.channelsFilter) || {};

  const handleDateChange = (date, type) => {
    setSelectedFeeds([]);
    setSelectedFeedsGroup([]);
    const formattedDate = date;
    if (type === "start") {
      setStartRange(formattedDate);
    } else {
      setEndRange(formattedDate);
    }
  };
  let selectedClientId = selectedClient && selectedClient.id;

  const concept_uid = getCookie(COOKIE.CONCEPT_USER_ID);  
  if(selectedClient.id != undefined && selectedClient.id != '' && selectedClient.id != null){   
    ReactGA.set({ userId: selectedClientId+".0."+concept_uid });
    ReactGA.set({ 'user_id': selectedClientId+".0."+concept_uid });
  }
  if(selectedClient.id != undefined && selectedClient.id != '' && selectedClient.id != null){ 
    ReactGA.event({
      category: "user_engagement",
      action: `TV Tab - `+selectedClientId+".0."+concept_uid,
      label: `TV Tab`, // optional
      //value: selectedClientId+"000"+concept_uid, // optional, must be a number
    });
  }

  useEffect(() => {
    if (selectedClient && selectedClient.id) {
      fetchTvDetails();
      setFilters((prevState) => {
        return { ...prevState, client: selectedClient.id };
      });
    }
  }, [selectedClient && selectedClient.id]);

  useEffect(() => {
    if (startRange && endRange && selectedClient && selectedClient.id) {
      fetchTvDetails();
    }
  }, [startRange, endRange]);
  useEffect(() => {
    initEntityFilter();
  }, [entityList]);

  const applyFilters = () => {
    fetchTvDetails();
  };
  const initEntityFilter = () => {
    if (selectAll) {
      setFilters((prevState) => {
        return { ...prevState, entity: entityList.map((e) => e.id) };
      });
    } else {
      setFilters((prevState) => {
        return { ...prevState, entity: [] };
      });
    }
  };
  const fetchTvDetails = () => {
    let params = {
      client_id: selectedClient.id,
      start_date: startRange,
      end_date: endRange,
      email: email,
      user_id: `${user_id}`,
    };
    const {
      entity,
      languages,
      anchor,
      channels,
      tonality,
      category,
      headline,
    } = filters;
    if (entity && entity.length) {
      params.entities = entity;
    }
    if (tonality) {
      params.tonality = tonality;
    }
    if (languages) {
      params.language_id = languages;
    }
    if (anchor) {
      params.anchor_id = anchor;
    }
    if (channels) {
      params.channel_id = channels;
    }
    if (headline) {
      params.headline = headline;
    }
    if (category) {
      params.category_id = category;
    }
    setIsLoading(true);
    if (selectedClient && selectedClient.id) {
      httpPost(`${envConfig.TV_NEWS}`, params)
        .then((res) => {
          const { result, message, status } = res.data;
          const { data } = result;
          setIsLoading(false);
          let totalFdCount = 0;
          for (const key of Object.keys(data)) {
            totalFdCount = totalFdCount + data[key].length;
          }
          setTotalFeedCount(totalFdCount);
          setTvFeeds(data);
        })
        .catch((e) => {
          console.log("[Error in TV feeds search]: ", e);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };
  const handleFeedGroupClick = (groupIdentifier) => {
    if (selectedFeedsGroup.indexOf(groupIdentifier) !== -1) {
      setSelectedFeedsGroup(
        selectedFeedsGroup.filter((g) => g !== groupIdentifier)
      );
    } else {
      setSelectedFeedsGroup([...selectedFeedsGroup, groupIdentifier]);
    }
  };
  const handleBulkUpdateSuccess = (
    bulkUpdatedSentiment,
    bulkUpdatedTheme,
    bulkUpdatedFavourite = undefined
  ) => {
    if (
      !bulkUpdatedTheme &&
      !bulkUpdatedSentiment &&
      bulkUpdatedFavourite == undefined
    ) {
      return;
    }
    setUpdatedBulkSentiment(bulkUpdatedSentiment);
    setUpdatedBulkTheme(bulkUpdatedTheme);
    if (bulkUpdatedFavourite != undefined) {
      setUpdatedBulkFavourite(bulkUpdatedFavourite);
    }
  };

  const handleSelectedFeeds = (selected, feedlist) => {
    let tempFeedsToShare = {};
    if (selected) {
      if (!Array.isArray(feedlist)) {
        tempFeedsToShare = [feedlist];
      } else {
        tempFeedsToShare = feedlist.map((elm) => {
          const {
            electronic_client_detail_id,
            article_id,
            edition,
            entity_id,
            entity_name,
            entity_type,
            headline,
            imagebaseurl,
            images,
            language,
            link,
            page_nos,
            photo,
            publication,
            publication_type,
            publish_date,
            reporter_name,
            source,
            source_name,
            summary,
            article_type,
            is_client_favourite,
            electronic_id,
            airing_time,
            channel_type,
            channel_name,
            program_name,
            duration,
            video_link,
            anchors,
            anchor_details,
            client_id,
            client_name,
            airing_date,
          } = elm;
          return {
            electronic_client_detail_id,
            client_id,
            client_name,
            headline,
            entity_id,
            entity_name,
            is_client_favourite,
            electronic_id,
            airing_time,
            channel_type,
            channel_name,
            program_name,
            duration,
            video_link,
            anchors,
            anchor_details,
            entity_type,
            imagebaseurl,
            images,
            language,
            link,
            page_nos,
            photo,
            publication,
            publication_type,
            publish_date,
            reporter_name,
            source,
            source_name,
            summary,
            article_type,
            airing_date,
          };
        });
      }
      setSelectedFeeds([...selectedFeeds, ...tempFeedsToShare]);
    } else {
      if (!Array.isArray(feedlist)) {
        setSelectedFeeds(
          selectedFeeds.filter((n) => n.electronic_id != feedlist.electronic_id)
        );
      } else {
        let tempArr = [...selectedFeeds];
        feedlist.forEach((element) => {
          tempArr = tempArr.filter((n) => {
            if (n.electronic_id !== element.electronic_id) return n;
          });
        });
        setSelectedFeeds(tempArr);
      }
    }
  };

  const renderDownloadIcon = (customParams = {}, isInlineDownload) => {
    const {
      zone,
      tonality,
      headline,
      keywords,
      entity,
      client,
      publication_type,
      edition,
      category,
      source_type,
      press_release,
      reporter,
    } = filters;

    return (
      <div className="downloadBtnWithText">
        <DownloadFeeds
          setIsLoading={setIsLoad}
          isLoading={isLoad}
          category={category}
          client_id={selectedClientId}
          // edition_id={edition}
          end_date={customParams.endDate || endRange}
          start_date={customParams.startDate || startRange}
          entities={entity}
          headline={arrayToString(headline)}
          // keywords={arrayToString(keywords)}
          // press_release={press_release}
          // publication_id={getCorrectPublication()}
          // publication_type={publication_type}
          // source_type={source_type}
          reporter={reporter}
          tonality={tonality}
          // zone={zone}
          client={client}
          // media_type={getCorrectVertical()}
          article={selectedFeeds}
          // customParams={customParams}
          // isInlineDownload={isInlineDownload}
          // onSuccessCallback={handleBulkUpdateSuccess}
          isTV
        />
      </div>
    );
  };
  return (
    <div
      className={
        !!selectedFeeds.length
          ? "mainContainer printOnlineContainer feedsSelected"
          : "mainContainer printOnlineContainer"
      }
    >
      <div className="dashboardHeader dashboardHeading">
        <div className="dashboardHeaderTop d-flex">
          <div className="dashboardMobileMenu">
            <button className="btn menuBtn" id="menuBtn">
              <MenuIcon />
            </button>
            <img src={"ConceptLogo"} width="32" height="32" />
          </div>
          <div className="dhLeft d-flex">
            <div className="dhLeftWrap d-flex align-items-center">
              <h1>TV</h1>
            </div>
          </div>
        </div>
        <div className="topFilterWrap">
          <div className="mobTopHeading">
            <h1>TV</h1>
          </div>
          <div className="titleRow printOnlineTitleRow">
            <div className="titleLeftWrap">
              <div className="filterWrap">
                <DateRangeFilter
                  handleDateChange={handleDateChange}
                  startRange={startRange}
                  endRange={endRange}
                  showShortCut
                  minDate={selectedClient ? selectedClient.start_date : null}
                  maxDate={selectedClient ? selectedClient.end_date : null}
                  // filterTab
                />
                {renderDownloadIcon()}
                <button
                  onClick={() => toggleFilter(true)}
                  className="btn filterBtn"
                >
                  <FilterIcon /> <span>Filters</span>
                </button>
              </div>
            </div>
            <div className="rightBtnContainer">
              {!!selectedFeeds.length && (
                <button className="btn optionBtn">
                  <div className="hasTooltip">
                    <ShareArticle
                      client_id={selectedClient.Id}
                      article={selectedFeeds}
                      isTV
                    />
                    <span className="tooltipWrap center">Share</span>
                  </div>
                </button>
              )}

              {!!selectedFeeds.length && (
                <ul className="dropDownContainer">
                  <ArticleTags
                    singleNewsGroup={selectedFeeds}
                    article={selectedFeeds}
                    onSuccessCallback={handleBulkUpdateSuccess}
                    forBulkUpdate
                    setUpdatedBulkSentiment={setUpdatedBulkSentiment}
                    setUpdatedBulkTheme={setUpdatedBulkTheme}
                    setUpdatedBulkFavourite={setUpdatedBulkFavourite}
                    showFavouriteTag
                    // isPrintAndOnline
                    isTV
                  />
                </ul>
              )}
              {renderDownloadIcon()}
              <button
                onClick={() => toggleFilter(true)}
                className="btn filterBtn"
              >
                <FilterIcon /> <span>Filters</span>
              </button>
              <div className={showFilter ? "show" : "hide"}>
                <Filters
                  toggleFilter={toggleFilter}
                  filters={filters}
                  setFilters={setFilters}
                  applyFilters={applyFilters}
                  client_id={selectedClientId}
                  // selectedVertical={getCorrectVertical()}
                  initEntityFilter={initEntityFilter}
                  // initLanguageFilter={initLanguageFilter}
                  handleDateChange={handleDateChange}
                  startRange={startRange}
                  endRange={endRange}
                  renderDownloadIcon={renderDownloadIcon}
                  selectedClient={selectedClient}
                  // selectedTab={V_PRINT_AND_ONLINE}
                  setApplyFilters={setApplyFilters}
                  setSelectAll={setSelectAll}
                  selectedAll={selectAll}
                  isTV
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {!isLoading && totalFeedCount && totalFeedCount > 0 ? (
        <div
          style={{
            color: "#0036b9",
            marginTop: "5px",
            marginBottom: "5px",
            fontSize: "14px",
          }}
        >
          {startRange == endRange && (
            <>
              Total <span className="feed-count-info">{totalFeedCount}</span>{" "}
              articles found on{" "}
              <span className="feed-count-info">
                {moment(startRange).format("Do MMMM YYYY")}
              </span>
            </>
          )}
          {startRange != endRange && (
            <>
              Total <span className="feed-count-info">{totalFeedCount}</span>{" "}
              articles were found from{" "}
              <span className="feed-count-info">
                {moment(startRange).format("Do MMMM YYYY")}
              </span>{" "}
              to
              <span className="feed-count-info">
                {moment(endRange).format("Do MMMM YYYY")}
              </span>
            </>
          )}
        </div>
      ) : (
        ""
      )}
      <div
        ref={listContainerRef}
        className="accordion accordionListWrap socialAccordionWrap"
      >
        {isLoading && <Loader />}
        {!tvFeeds ||
          (!isLoading && !Object.keys(tvFeeds).length && (
            <div className="noFilterDataWrap">
              <NoFeedIcon />
              <h6>No Feeds Found</h6>
              <p>Try adjusting the filters to find what you’re looking for</p>
            </div>
          ))}
        {!isLoading &&
          Object.keys(tvFeeds).map((topic, index) => {
            const feeds = tvFeeds[topic];
            const data = {
              entityName: topic,
              // entityId: item.entity_id,
              tvData: feeds,
              // type: VERTICALS.V_SOCIAL,
              total: feeds.length,
            };
            return (
              <TopicWiseNewsContainer
                listContainerRef={listContainerRef}
                key={index + 1}
                // currentEntityName={item}
                listkey={index + 1}
                entityFeeds={data}
                activeKey={activeKey}
                setActiveKey={setActiveKey}
                // allArticleList={allArticleList}
                onFeedSelect={handleSelectedFeeds}
                selectedFeeds={selectedFeeds}
                selectedFeedsGroup={selectedFeedsGroup}
                setSelectedFeedsGroup={setSelectedFeedsGroup}
                handleFeedGroupClick={handleFeedGroupClick}
                onSuccessCallback={handleBulkUpdateSuccess}
                forBulkUpdate
                updatedBulkSentiment={updatedBulkSentiment}
                updatedBulkTheme={updatedBulkTheme}
                updatedBulkFavourite={updatedBulkFavourite}
                // filters={filters}
                // selectedClientId={selectedClientId}
                // customParams={customParamsData}
                startRange={startRange}
                endRange={endRange}
                // applyFilters={appliedFilters}
                // setApplyFilters={setApplyFilters}
                isTV
              />
            );
          })}
      </div>
    </div>
  );
}
